import { render, staticRenderFns } from "./KonvaAutomationInlineAdd.vue?vue&type=template&id=50cbf01a"
import script from "./KonvaAutomationInlineAdd.vue?vue&type=script&lang=js"
export * from "./KonvaAutomationInlineAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports